export default {
  AMAP_READY_EVENT: 'AMAP_READY_EVENT'
};
